import {axios} from ".";
import config from '../config.json';

export const succesfullLogin = async (username, role) => {
  try{
    await axios.post(`${config.base_url_api}/loginAttempt/`, {
      username,
      role,
      "faults": 0,
      "status": "success"
    });
  }catch(error)
  {
    throw new Error(error)
  }
};

export const failedLogin = async (username, role, attempt, status) => {
  try{
    await axios.post(`${config.base_url_api}/loginAttempt/`, {
      username,
      role, 
      faults: attempt,
      status
    });
  }catch(error)
  {
    throw new Error(error)
  }
};

export const getAll = async () => {
  const {
    data
  } = await axios.get(`${config.base_url_api}/loginAttempt/`);
  return data;
}